import { useState } from "react"
import PropTypes from "prop-types"
import UpgradeToProModal from "app/components/upgrade_to_pro_modal"

import "./upsell.scss"

export default function Upsell({
  extraClass,
  proPlusProductId,
  proPlusSubscriptionUrl,
  proSubscriptionUrl,
  remaining,
  subscriptionPaymentType,
  tier,
  total,
  trialing,
}) {
  if (["pro", "legacy_pro"].includes(tier)) {
    return ""
  }

  const [showModal, updateShowModal] = useState(false)

  let copy = "Get Pro to get 20 Applets"
  let link = proSubscriptionUrl
  let object_id = "pro_link"

  if (tier === "intermediate_pro") {
    copy = "Get Pro+ for unlimited Applets"
    link = proPlusSubscriptionUrl
    object_id = "pro_plus_link"
  }

  const handleOnClick = e => {
    if (tier === "intermediate_pro") {
      e.preventDefault()
      updateShowModal(true)
    }
  }
  return (
    <>
      <a
        href={link}
        onClick={handleOnClick}
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify({
          object_id,
          object_type: "pro_upsell",
          location_type: "my_applets",
        })}
        className="link-standalone"
        styleName={`pro-upsell ${extraClass}`}
      >
        {copy}
      </a>
      {tier === "intermediate_pro" && (
        <UpgradeToProModal
          visible={showModal}
          step="applet_quota"
          newProSubscriptionUrl={proSubscriptionUrl}
          newProPlusSubscriptionUrl={proPlusSubscriptionUrl}
          onUpgrade={() => {
            window.appendFlash(
              "Upgrade complete. Welcome to IFTTT Pro!",
              "success",
              () => window.location.reload()
            )
          }}
          onClose={() => updateShowModal(false)}
          appletsInUse={total - remaining}
          appletQuotaTotal={total}
          eligibleForTrial={false}
          currentTier={tier}
          subscriptionPaymentType={subscriptionPaymentType}
          proPlusProductId={proPlusProductId}
          appletFeatureFlags={false}
          isTrialing={trialing}
          trackLocationType="my_applets"
        />
      )}
    </>
  )
}

Upsell.propTypes = {
  extraClass: PropTypes.string,
  proPlusSubscriptionUrl: PropTypes.string.isRequired,
  proPlusProductId: PropTypes.string.isRequired,
  proSubscriptionUrl: PropTypes.string.isRequired,
  remaining: PropTypes.number.isRequired,
  subscriptionPaymentType: PropTypes.string.isRequired,
  tier: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  trialing: PropTypes.number.isRequired,
}

Upsell.defaultProps = {
  extraClass: "",
}
